/*=========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally

  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Header from './views/Self-Improvee/Generic/Header.vue'
import VxTooltip from './layouts/components/vx-tooltip/VxTooltip.vue'
import VxCard  from './components/vx-card/VxCard.vue'
import VxList  from './components/vx-list/VxList.vue'
import VxBreadcrumb  from './layouts/components/VxBreadcrumb.vue'
import FeatherIcon  from './components/FeatherIcon.vue'
import VxInputGroup  from './components/vx-input-group/VxInputGroup.vue'
import Deadline  from './views/Self-Improvee/Generic/Deadline.vue'
import MultiSelect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import DeadlinePicker from './views/Self-Improvee/Generic/DeadlinePicker.vue'
import AnchoredTitle from './views/Self-Improvee/Generic/AnchoredTitle.vue'
import InfoPopup from './views/Self-Improvee/Generic/InfoPopup.vue'
import InfoCard from './views/Self-Improvee/Generic/InfoCard.vue'
import SidebarLabel from './views/Self-Improvee/Generic/SidebarLabel.vue'
import EmptyState from './views/Self-Improvee/Generic/EmptyState.vue'
import PlannerHeader from './views/Self-Improvee/Planner/PlannerHeader.vue'
import NoProgressFor from './views/Self-Improvee/Goals/NoProgressFor.vue'
import FrequencyInWords from './views/Self-Improvee/Routines/FrequencyInWords.vue'
import ExistsFor from './views/Self-Improvee/Tasks/ExistsFor.vue'
import TasksDivider from './views/Self-Improvee/Tasks/TasksDivider.vue'
import Loader from './views/Self-Improvee/Generic/Loader'
import FilterOptions from './views/Self-Improvee/Generic/FilterOptions'
import ContextMenuItem from './views/Self-Improvee/Generic/ContextMenuItem'
import ContextMenuNextDays from './views/Self-Improvee/Generic/ContextMenuNextDays'
import ContextMenuColor from './views/Self-Improvee/Generic/ContextMenuColor'
import ColorPicker from '@/views/Self-Improvee/Generic/ColorPicker'
import InviteFriendPopup from '@/views/Self-Improvee/Generic/InviteFriendPopup'
import GeneralPopup from '@/views/Self-Improvee/Generic/GeneralPopup'
import Dot from '@/views/Self-Improvee/Generic/Dot'
import AppNotifications from '@/views/Self-Improvee/Notifications/AppNotifications'
import DownloadApp from '@/views/Self-Improvee/Notifications/DownloadApp'
import EarnPassiveIncome from '@/views/Self-Improvee/Notifications/EarnPassiveIncome'
import AiCoaching from '@/views/Self-Improvee/Notifications/AiCoaching'
import AiTip from '@/views/Self-Improvee/Notifications/AiTip'
import SecondDay from '@/views/Self-Improvee/Notifications/SecondDay'
import FourDayStreak from '@/views/Self-Improvee/Notifications/FourDayStreak'
import AfterOneWeek from '@/views/Self-Improvee/Notifications/AfterOneWeek'
import AfterOneMonth from '@/views/Self-Improvee/Notifications/AfterOneMonth'
import ImproveeAi from '@/views/Self-Improvee/Notifications/ImproveeAi'
import FirstExperience from '@/views/Self-Improvee/Notifications/FirstExperience'
import PickContextMenu from '@/views/Self-Improvee/Generic/PickContextMenu'
import ContextMenuPick from '@/views/Self-Improvee/Generic/ContextMenuPick'
import SidebarTitle from '@/views/Self-Improvee/Generic/SidebarTitle'
import GoodNotSoGood from '@/views/Self-Improvee/Generic/GoodNotSoGood'
import BackgroundPicker from '@/views/Self-Improvee/Generic/BackgroundPicker'
import InviteFriends from '@/views/Self-Improvee/Generic/InviteFriends'
import RelatedAreas from '@/views/Self-Improvee/Generic/RelatedAreas'
import MakeIt from '@/views/Self-Improvee/Generic/MakeIt'
import Editor from '@/views/Self-Improvee/Generic/Editor'
import ActionBoardFilter from '@/views/Self-Improvee/Generic/ActionBoardFilter'
import Checkbox from '@/views/Self-Improvee/Onboarding/Wizard/Checkbox'

import contextMenu from 'vue-context-menu'

Vue.component(Header.name, Header)
Vue.component(VxTooltip.name, VxTooltip)
Vue.component(VxCard.name, VxCard)
Vue.component(VxList.name, VxList)
Vue.component(VxBreadcrumb.name, VxBreadcrumb)
Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(VxInputGroup.name, VxInputGroup)
Vue.component(VxInputGroup.name, VxInputGroup)
Vue.component('MultiSelect', MultiSelect)
Vue.component('Deadline', Deadline)
Vue.component('DeadlinePicker', DeadlinePicker)
Vue.component('AnchoredTitle', AnchoredTitle)
Vue.component('PlannerHeader', PlannerHeader)
Vue.component('InfoPopup', InfoPopup)
Vue.component('InfoCard', InfoCard)
Vue.component('NoProgressFor', NoProgressFor)
Vue.component('ExistsFor', ExistsFor)
Vue.component('SidebarLabel', SidebarLabel)
Vue.component('FrequencyInWords', FrequencyInWords)
Vue.component('EmptyState', EmptyState)
Vue.component('Loader', Loader)
Vue.component('TasksDivider', TasksDivider)
Vue.component('FilterOptions', FilterOptions)
Vue.component('contextMenu', contextMenu)
Vue.component('ContextMenuItem', ContextMenuItem)
Vue.component('ContextMenuNextDays', ContextMenuNextDays)
Vue.component('ContextMenuColor', ContextMenuColor)
Vue.component('ColorPicker', ColorPicker)
Vue.component('InviteFriendPopup', InviteFriendPopup)
Vue.component('Dot', Dot)
Vue.component('AppNotifications', AppNotifications)
Vue.component('GeneralPopup', GeneralPopup)
Vue.component('DownloadApp', DownloadApp)
Vue.component('PickContextMenu', PickContextMenu)
Vue.component('ContextMenuPick', ContextMenuPick)
Vue.component('SidebarTitle', SidebarTitle)
Vue.component('GoodNotSoGood', GoodNotSoGood)
Vue.component('BackgroundPicker', BackgroundPicker)
Vue.component('InviteFriends', InviteFriends)
Vue.component('RelatedAreas', RelatedAreas)
Vue.component('MakeIt', MakeIt)
Vue.component('Checkbox', Checkbox)
Vue.component('Editor', Editor)
Vue.component('ActionBoardFilter', ActionBoardFilter)
Vue.component('EarnPassiveIncome', EarnPassiveIncome)
Vue.component('AiCoaching', AiCoaching)
Vue.component('AiTip', AiTip)
Vue.component('ImproveeAi', ImproveeAi)
Vue.component('FirstExperience', FirstExperience)
Vue.component('SecondDay', SecondDay)
Vue.component('FourDayStreak', FourDayStreak)
Vue.component('AfterOneWeek', AfterOneWeek)
Vue.component('AfterOneMonth', AfterOneMonth)

// v-select component
import vSelect from 'vue-select'

// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'XIcon',
        svgClasses: 'w-4 h-4 mt-1'
      }
    })
  },
  OpenIndicator: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'ChevronDownIcon',
        svgClasses: 'w-5 h-5'
      }
    })
  }
})

Vue.component(vSelect)
